import template from './socialSecurityCard.html';
import './socialSecurityCard.scss';

let socialSecurityCardComponent = {
  restrict: 'E',
  bindings: {
    ssData : '<',
  },
  template
};

export default socialSecurityCardComponent;



// WEBPACK FOOTER //
// ./client/app/social-security.module/components/socialSecurityCard/socialSecurityCard.component.js